import AbstractFetch from '~/repositories/AbstractFetch';
import type { IFetchOptions, IResponse } from '~/types/repositories';
import type {
  IApiFormFactorList,
  IApiFormFactor,
  IApiConfiguration,
} from '~/modules/constructor/types';

export default class Constructor extends AbstractFetch {
  private static readonly FORM_FACTORS = 'v1/constructor/form-factors';
  private static readonly CONFIGURATION = 'v1/constructor/configuration';
  private static readonly ADD_TO_CART = 'v1/constructor/add-to-cart';

  constructor(fetchOptions: IFetchOptions) {
    super(fetchOptions.baseURL, fetchOptions.fetch);
  }

  async getFormFactors(): Promise<IResponse<IApiFormFactorList[]>> {
    return this.fetch(Constructor.FORM_FACTORS);
  }

  async getFormFactor(id: number): Promise<IResponse<IApiFormFactor>> {
    return this.fetch(`${Constructor.FORM_FACTORS}/${id}`);
  }

  async getConfiguration(params: {
    ff: number;
    case: number;
    dial: number;
    hands: number;
    strap: number;
  }): Promise<IResponse<IApiConfiguration>> {
    const queryParams = `ff=${params.ff}&case=${params.case}&dial=${params.dial}&hands=${params.hands}&strap=${params.strap}`;
    return this.fetch(Constructor.CONFIGURATION, { queryParams });
  }

  async addToCart(body: {
    form_factor_id: number;
    case_product_id: number;
    dial_product_id: number;
    hands_product_id: number;
    strap_product_id: number;
    services?: Array<{
      offer_id: number;
      metadata?: { line1?: string; line2?: string } | null;
    }>;
  }): Promise<IResponse<{ success: boolean }>> {
    return this.fetch(Constructor.ADD_TO_CART, { method: 'POST', body });
  }
}
